
import OrderList from "@/components/primevueCustom/OrderList.vue";
import { IAlert, ResultDatas } from "@/models/common";
import {
  IDoctorListItem,
  IDoctor,
  IFacilityDept,
  ISaveMyDoctorInfo,
  DoctorListEvents,
  PossibleTypes,
} from "@/models/doctor";
import $API from "@/services";
import { useI18n } from "vue-i18n";
import { computed, defineComponent, onMounted, PropType, reactive, Ref, ref, watch } from "vue";
import { messageType } from "@/models/message";
import Dropdown, { DropdownChangeEvent } from "primevue/dropdown";
// import RadioButton from "primevue/radiobutton";
import Paginator from "primevue/paginator";
import { useStore } from "vuex";
import { CommonMutationTypes } from "@/store/modules/common/mutations";
import DoctorItemOptions from "@/components/common/Doctors/DoctorItemOptions.vue";
import { IFacility } from "@/models/facility";
import { getFacilityDoctorList, DoctorService } from "@/services/doctor";
import { IResponseData } from "@/models/common";
import { AppointmentTypes } from "@/models/request";

import _ from "lodash";
import { RequestMutationTypes } from "@/store/modules/request/mutations";

export default defineComponent({
  name: "Doctor List",
  emits: [DoctorListEvents.SelectedDoctor],
  props: {
    doctors: {
      type: Object as PropType<IDoctor>,
      required: true,
    },
    required: Boolean, //필수입력값 표시여부
    isEditable: Boolean,
    notSelectable: Boolean,
    possibleTypes: {
      type: Number as PropType<PossibleTypes>,
      required: true,
    },
    isHeight: {
      type: Boolean,
      default: true,
    },
    isFavorite: {
      type: Boolean,
      default: false,
    },
    hcode: String,
    dcode: String,
  },
  setup(props, { emit }) {
    const { t } = useI18n({ useScope: "global" });
    const store = useStore();
    const doctor: IDoctor = reactive({
      selectedDept: {} as IFacilityDept,
      doctorList: props.doctors.doctorList,
      doctorListSplit: props.doctors.doctorListSplit,
      selectedFacility: props.doctors.selectedFacility,
      selectedDoctor: props.doctors.selectedDoctor,
      selectedPage: props.doctors.selectedPage,
      displayDoctorRow: props.doctors.displayDoctorRow,
    });

    const selectMyDoctorName = ref("");

    const isNotSelectable = ref(props.notSelectable);

    const selectedAppointmentType = ref(1)

    const selectedFacilityKey = ref(0);
    const filteredDeptKey = ref();

    const isRequired = ref(!!props.required);
    const isHeightLimit = ref(props.isHeight);

    const toggleTargetDoctor: Ref<IDoctorListItem> = ref({} as IDoctorListItem);

    const countMyDoctor = ref(0);

    const alert: Ref<IAlert> = ref({
      type: messageType.ERROR,
      content: "",
    });

    // dept. dropdown
    const depts = reactive({
      select: null as null | Number,
      list: [] as Array<IFacilityDept>,
      displayList: [] as Array<IFacilityDept>,
    });

    const isOnlineCareRequest = computed(()=>{
      return props.possibleTypes === PossibleTypes.ONLINE_CARE;
    });

    const isVisibleDoctorList  = computed(() => {
      if(!isOnlineCareRequest.value) return true;

      return selectedAppointmentType.value === AppointmentTypes.Telemedicine;
    });

    const loadFacilityList = async () => {
      try {
        const facilityData = await $API.FacilityService.getHospitalList();
        if (!Array.isArray(facilityData)) return;

        facilityList.value = facilityData;
      } catch (ex) {
        if (typeof ex === "string") {
          alert.value.content = ex as string;
        } else {
          const { Exception } = ex as IResponseData<any>;
          alert.value.content = Exception;
        }
      }
    };

    const loadFacilityDoctorList = async (hid: number) => {
      try {
        console.log(props.possibleTypes, "DoctorList.props.possibleTypes");
        const doctors = await getFacilityDoctorList(props.possibleTypes, hid ?? 0);
        if (!Array.isArray(doctors)) return;

        doctor.doctorList = doctors;
        console.log(doctors, "loadFacilityDoctorList.doctors");

        console.log(doctor.displayDoctorRow, "doctor.displayDoctorRow");

        if (!doctor.displayDoctorRow) {
          doctor.doctorListSplit = [doctor.doctorList];
          doctor.selectedPage = 0;
        } else {
          if (props.isEditable)
            doctor.doctorListSplit = _.chunk(doctor.doctorList, doctor.displayDoctorRow.valueOf());
          else {
            doctor.doctorList = doctor.selectedDoctor;
            doctor.doctorListSplit = [doctor.selectedDoctor];
            doctor.selectedPage = 0;
          }
        }

        console.log(doctor.doctorListSplit, "doctor.doctorListSplit");

        await updateDoctorListByFilters(filteredDeptKey.value);

        await updateDeptDisplayList();
      } catch (ex) {
        console.error(ex);
      }
    };

    const loadDeptList = async () => {
      try {
        const deptDatas = await DoctorService.getDeptsList();
        if (!Array.isArray(deptDatas)) return;
        depts.list = deptDatas;

        updateDeptDisplayList();
      } catch (ex) {
        console.warn(ex);
      }
    };

    
    watch(
      () => props.hcode,
      (newCode?: string) => {
        console.log("newCode=>", newCode);
        if(newCode) {
         selectFacilityByCode(newCode)
        }
      }
    );

    // 진료과 선택값이 변경되면 진료과로 핕터링함.
    watch(
      () => depts.select,
      async (n) => {
        filteredDeptKey.value = n;

        console.log("Dept.selected=>", depts.select);

        updateDoctorListByFilters(filteredDeptKey.value);

        if (n) {
          const matchedDept = depts.displayList.find((x) => x.DeptKey === n);
          if (matchedDept) {
            doctor.selectedDept = matchedDept;
            emit(DoctorListEvents.SelectedDoctor, doctor);
          } else {
            emit(DoctorListEvents.SelectedDoctor, null);
          }
        } else {
          emit(DoctorListEvents.SelectedDoctor, null);
        }
        //   displayList.value = [];

        //   if (!filteredDeptKey.value) {
        //     displayList.value =
        //       doctor.doctorListSplit[doctor.selectedPage.valueOf()];
        //   } else {
        //     const filterList = await Promise.all(
        //       doctor.doctorList.filter((item) => {
        //         return item.DeptKey === filteredDeptKey.value;
        //       })
        //     );
        //     //await Promise.all(
        //     displayList.value = filterList;
        //   }

        //   if (props.isFavorite) {
        //     displayList.value = displayList.value.filter((x) => x.MyDoctor);
        //   }
      }
    );

    const updateDoctorListByFilters = async (deptKey: number) => {
      displayList.value = [];

      if (deptKey > 0) {
        const filterList = await Promise.all(
          doctor.doctorList.filter((item) => {
            return item.DeptKey === deptKey;
          })
        );
        displayList.value = filterList;
      } else {
        console.log("doctor.selectedPage->", doctor.selectedPage);
        console.log("doctor.doctor.doctorListSpli->", doctor.doctorListSplit.values);
        displayList.value = doctor.doctorListSplit[doctor.selectedPage.valueOf()];
        console.log("doctor.displayList->", displayList);
      }

      if (props.isFavorite) {
        displayList.value = displayList.value.filter((x) => x.MyDoctor);
      }
    };

    // 가져온 진료과 중 의사가 있는 진료과만 표시
    const updateDeptDisplayList = async () => {
      // 의사읠 진료과 Key 조회
      const doctorDeptKeys = await Promise.all(
        doctor.doctorList
          .map((x) => x.DeptKey)
          .reduce((u: Array<Number>, i: Number) => {
            return u.includes(i) ? u : [...u, i];
          }, [])
      );
      console.log("updateDeptDisplayList:doctorDeptKeys=>", depts.displayList);

      // 의사 진료과 Key로 목록 생성
      depts.displayList = await Promise.all(
        depts.list.filter((x) => doctorDeptKeys.includes(x.DeptKey))
      );

      console.log("updateDeptDisplayList:displayList=>", depts.displayList);
    };

    // 병원 목록
    const facilityList: Ref<Array<IFacility>> = ref([]);

    //보여줄 의사 리스트
    const displayList: Ref<Array<IDoctorListItem>> = ref([]);

    const countedMydoctor = async () => {
      countMyDoctor.value = 0;

      const count = await Promise.all(displayList.value.filter(async (x) => x.MyDoctor));
      countMyDoctor.value = count.length;
    };

    // 병원코드로 병원 선택
    const selectFacilityByCode = async (hcode:string, dcode?:string) => {
      console.log("selectFacilityByCode=>", hcode, dcode);

      const matchedFacility = facilityList.value.find(
          (x) => x.FacilityCode === hcode
        );

      if (matchedFacility) {
        console.log("selectFacilityByCode: matchedFacility=>", matchedFacility);

        selectedFacilityKey.value = matchedFacility.FacilityKey.valueOf();

        await loadFacilityDoctorList(selectedFacilityKey.value);

        console.warn("selectFacilityByCode=>", dcode);

        doctor.selectedFacility = matchedFacility;

        if (dcode) {
          selectDeptByCode(dcode);
          // const matchedDoctor = doctor.doctorList.find(
          //   (x) => x.DeptId === props.dcode
          // );
          // if (matchedDoctor) {
          //   doctor.selectedDoctor = [matchedDoctor];
          // }
        }
        //applyDcodeMatch();
      }
      else {
        doctor.selectedFacility = null;
      }
    };

    // 진료과코드로 진료과 선택
    const selectDeptByCode = async (dcode:string) => {
      console.log("selectDeptByCode=>", dcode);

      const matchedDept = depts.displayList.find(
              (x) => x.DeptId === dcode
            );
            if (matchedDept) {
              depts.select  = matchedDept.DeptKey;
            }
    };

    // dcode로 의사 자동 선택 (의사 목록이 로드된 뒤 호출)
    // const applyDcodeMatch = () => {
    //   if (!props.dcode) return;

    //   const matchedDoctor = doctor.doctorList.find((x) => x.DeptId === props.dcode);
    //   if (matchedDoctor) {
    //     doctor.selectedDoctor = [matchedDoctor];
    //   }
    // };

    onMounted(async () => {
      console.log("DoctorList:onMounted");

      store.commit(CommonMutationTypes.SET_IS_LODING, true);
      if (doctor && doctor.doctorList) {
        console.log(doctor, "DoctorList.onMounted.doctor");
        displayList.value = doctor.doctorListSplit[doctor.selectedPage.valueOf()];
        if (props.isFavorite) {
          displayList.value = displayList.value.filter((x) => x.MyDoctor);
        }

        selectedFacilityKey.value = doctor.selectedFacility?.FacilityKey?.valueOf() ?? 0;
      }

      await loadFacilityList();

      if (props.hcode) {
        selectFacilityByCode(props.hcode, props.dcode);
      }

      await loadDeptList();

      await countedMydoctor();

      store.commit(CommonMutationTypes.SET_IS_LODING, false);
    });

    


    return {
      doctor,
      props,
      t,
      isRequired,
      isOnlineCareRequest,
      isVisibleDoctorList,
      alert,
      displayList,
      depts,
      emit,
      isNotSelectable,
      toggleTargetDoctor,
      isHeightLimit,
      countMyDoctor,
      countedMydoctor,
      store,
      selectMyDoctorName,
      loadFacilityDoctorList,
      // applyDcodeMatch,
      facilityList,
      selectedFacilityKey,
      selectedAppointmentType,
      AppointmentTypes,
    };
  },
  methods: {
    /**
     * orderlist update:selection event 받아서 selectedDoctor emit
     */
    onUpdateSelection(val: Array<IDoctorListItem>) {
      if (this.isNotSelectable) return;
      this.doctor.selectedDoctor = val;

      console.log("onUpdateSelection=>", val);
      this.emit(DoctorListEvents.SelectedDoctor, this.doctor);
    },

    /**
     * 의사 즐겨찾기(마이닥터) click event
     */
    async onToggleFavorites(doctor: IDoctorListItem) {
      const params: ISaveMyDoctorInfo = {
        DoctorKey: doctor.DoctorKey.valueOf(),
        MyDoctor: 1 >> doctor.MyDoctor,
      };

      try {
        const success = await $API.DoctorService.SaveMyDoctorInfo(params);

        if (ResultDatas.SUCCESS === success) {
          doctor.MyDoctor = 1 >> doctor.MyDoctor;
        }
      } catch (ex) {
        console.warn(ex);
      }

      const selectedDoctor = await Promise.all(
        this.doctor.doctorList.filter((x) => x.DoctorKey === doctor.DoctorKey)
      );
      this.toggleTargetDoctor = selectedDoctor[0];

      if (doctor.MyDoctor === 1) {
        this.selectMyDoctorName = doctor.DoctorName.valueOf();
        this.alert = {
          content: this.t("toggle favarite doctor"),
          type: messageType.INFO,
        };
      }
      await this.countedMydoctor();
    },

    /**
     * 진료유형(방문/비대면) 선택 change event
     */
    onCheckedAppointmentType(e: Event) {
      const target = e.target as HTMLInputElement;
      console.log(target.value, "onCheckedAppointmentType.select.e");
      console.log(this.selectedFacilityKey, "this.selectedFacilityKey");
      this.selectedAppointmentType = Number(target.value);

      this.loadFacilityDoctorList(this.selectedFacilityKey);

      // if (this.selectedAppointmentType === AppointmentTypes.Telemedicine && this.selectedFacilityKey) {
      //   this.loadFacilityDoctorList(this.selectedFacilityKey);
      // } else {
      //   this.loadFacilityDoctorList(0);
      // }

      this.store.commit(RequestMutationTypes.SET_APPOINT_TYPE, this.selectedAppointmentType);
    },

    async onChangedRequestingFacility(e: DropdownChangeEvent) {
      console.log(e, "onChangedHospital.select.e");
      console.log(this.selectedFacilityKey, "selectedFacility");

      // 병원 의사 조회
      await this.loadFacilityDoctorList(e.value);

      this.doctor.selectedFacility = this.facilityList.find((v)=>{
        return v.FacilityKey === this.selectedFacilityKey;
      });
      this.doctor.selectedDept = null;
      this.doctor.selectedDoctor = [];

      this.emit(DoctorListEvents.SelectedDoctor, this.doctor);
      // this.applyDcodeMatch();

      // if (this.selectedAppointmentType === AppointmentTypes.Telemedicine) {
      //   // 병원 의사 조회
      //   await this.loadFacilityDoctorList(e.value);
      // }
    },
 
  },

  components: {
    OrderList,
    Dropdown,
    Paginator,
    DoctorItemOptions,
    // RadioButton
  },

   computed: {
    // ...mapGetters(["getHospCode", "getDeptCode"]),
  },
});
